"use client"

import { IoShareOutline } from "react-icons/io5"
import { Drawer, DrawerContent, DrawerTitle } from "@mylaunch/components/ui"

export function IOSInstallSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Drawer open={open} onOpenChange={(v) => !v && onClose()}>
      <DrawerContent
        handle={false}
        showCloseButton
        className="rounded-t-xl p-0 gap-0 border-0 outline-none max-h-[80vh] overflow-y-auto"
      >
          <div className="flex items-center justify-center h-32 rounded-lg bg-primary/10 text-6xl">
            🔔
          </div>
        <div className="flex flex-col gap-s p-m">
          <DrawerTitle lang="ru" className="font-bold text-xl hyphens-auto">
            Установите GWService
          </DrawerTitle>
          <p className=" hyphens-auto text-secondary bg-primary/10 rounded-md p-s">
            Добавьте приложение на главный экран — заходить будет быстрее, а уведомления придут прямо на телефон.
          </p>
          <div className="">
            Нажмите <IoShareOutline className="text-secondary inline size-icon-m -mt-0.5" /> в меню браузера, затем «На экран Домой»
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
